import React from 'react';
import Storage from 'dashboards/Storage';
//import RecentClients from 'dashboards/RecentClients';
import RecentReports from 'dashboards/RecentReports';
import RecentCharts from 'dashboards/RecentCharts';
import RecentPatients from 'dashboards/RecentPatients';
import useStyles from './Home.styles';
import Announcement from 'components/Announcement';
import { Typography } from '@mui/material';



const Home = () => {
	const classes = useStyles();
	return (
		<div>
			<div className={classes.flexContainer}>
				<Announcement
					variant="blueGrey"
					size="xl"
					headerContent={
						<Typography variant="h6" color="inherit" align="left">Welcome!</Typography>
					}
				>
					<Typography gutterBottom>
						Hi there!
					</Typography>
				</Announcement>


				<RecentCharts />

				<RecentPatients />

				<RecentReports />

				<Storage />


			</div>
		</div>
	);
};



export default Home;
